<template>
  <div class="hpanel no-margins" :class="type === 'similar' ? 'panel-collapse' : ''">
    <template v-if="searchState">

      <list-companies-results v-if="companies" :context="context" v-model="companies"
                              :nbEstimateCompanies="nbEstimateCompanies"
                              :nbCompanies="allCompanies.length"
                              :listType="listType" :changeSort="changeSort"/>

    </template>
    <template v-else>
      <template v-if="companies.length === 0">
        <div class="panel-body">
          <div class="text-center">
            <h2 class="m-b-xs" v-if="type === 'selected'">Empty list – selected companies</h2>
            <h2 class="m-b-xs" v-else-if="type === 'similar'">Empty list – similar companies</h2>
            <div class="m">
              <i class="pe-7s-search fa-5x"></i>
            </div>
            <p class="small"></p>

            <router-link v-if="!$user.isBasic()" class="btn btn-info btn-sm" :to="{name: 'Search'}">Explore and fill list of companies</router-link>
            <button v-else class="btn btn-info btn-sm" @click="context.showLimitPlan('explore')">Explore and fill list of companies</button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="panel-heading hbuilt">

          <div class="row">
            <div class="col-xs-3">
              <template v-if="type === 'selected'">
                <h4>Selected Company ({{companies.length}})</h4>
              </template>
              <template v-else-if="type === 'similar'">
                <h4>Similar Company ({{companies.length}})</h4>
              </template>
            </div>
            <div class="col-xs-8" style="height: 40px">
              <filters :type="listType" :workflow-id="2" :context="context"></filters>
            </div>
            <div class="col-xs-1">
              <div class="panel-tools m-t-xs">
                <a class="showhide" @click="showHidePanelList">
                  <i class="fa" :class="type === 'similar' ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </a>
              </div>
            </div>
          </div>

        </div>
        <div class="panel-body no-padding">
          <template v-if="type === 'selected'">
            <list-companies-selected :context="context" v-model="companies" :biblio="biblio"
                                     :nbCompanies="allCompanies.length"
                                     :listType="listType" :changeSort="changeSort"/>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>

import Filters from './../filter/Filters'
import ListCompaniesResults from './ListCompaniesResults'
import ListCompaniesSelected from './ListCompaniesSelected'
export default {
  components: {
    ListCompaniesSelected,
    ListCompaniesResults,
    Filters
  },
  props: ['allCompanies', 'type', 'listId', 'companiesSelected', 'companiesSimilar', 'context',
    'biblio', 'nbEstimateCompanies', 'searchState', 'listType', 'searchType', 'project'],
  name: 'ListCompanies',
  data () {
    return {
      localAllCompanies: [],
      companies: [],
      sort: {
        col: 'score',
        order: 'desc'
      }
    }
  },
  watch: {
    'context.expertSourceSelected': function () {
      this.initCompanies()
    },
    'context.countriesSelected': function () {
      this.initCompanies()
    },
    'context.categorySelected': function () {
      this.initCompanies()
    },
    'context.affiliationTypeSelected': function () {
      this.initCompanies()
    },
    'context.dateIncorporateSelected': function () {
      this.initCompanies()
    },
    allCompanies: function (val) {
      this.localAllCompanies = val
    },
    localAllCompanies: function (val) {
      if (val.length !== 0 && this.listId !== null) {
        this.initCompanies()
      } else {
        this.companies = []
      }
    },
    companiesSelected: function () {
      this.identifySelectedAndSimilarCompanies(this.companies)
    },
    'biblio.content': function (content) {
      this.setSelectedDocumentInBiblio()
    }
  },
  methods: {
    setSelectedDocumentInBiblio: function () {
      if (this.biblio !== null && typeof this.biblio.content !== 'undefined') {
        let content = JSON.parse(this.biblio.content)
        let documentsId = {}
        documentsId = this.getDocumentSelectedInBiblio(content)

        this.companies.forEach((company) => {
          let documentsUpdated = false

          let documents = company.docs.map((document) => {
            let wasBilbio = document.biblio
            document.biblio = documentsId[document.documentID] === true
            if ((typeof wasBilbio === 'undefined' && document.biblio === true) ||
                (typeof wasBilbio !== 'undefined' && wasBilbio !== document.biblio)) {
              documentsUpdated = true
            }
            return document
          })

          if (documentsUpdated === true) {
            company.docs = documents
          }
        })
      }
    },
    getDocumentSelectedInBiblio: function (nodes) {
      let documentsId = {}

      for (let keyNode in nodes) {
        if (!nodes.hasOwnProperty(keyNode)) { continue }
        if (typeof nodes[keyNode]['documents'] !== 'undefined') {
          for (let documentKey in nodes[keyNode]['documents']) {
            if (!nodes[keyNode]['documents'].hasOwnProperty(documentKey)) { continue }
            documentsId[nodes[keyNode]['documents'][documentKey]['id']] = true
          }
        }
      }
      return documentsId
    },
    initCompanies: function () {
      let companies = Object.assign([], this.localAllCompanies)

      if (this.context.countriesSelected.length === 0 && this.context.categorySelected.length === 0 &&
          this.context.affiliationTypeSelected.length === 0 && this.context.dateIncorporateSelected.length === 0 &&
          this.context.expertSourceSelected.length === 0) {
        this.context.filterSelected = null
      } else {
        if ((this.context.countriesSelected.length === 0 && this.context.filterSelected === 'country') ||
            (this.context.categorySelected.length === 0 && this.context.filterSelected === 'category') ||
            (this.context.affiliationTypeSelected.length === 0 && this.context.filterSelected === 'affiliationType') ||
            (this.context.dateIncorporateSelected.length === 0 && this.context.filterSelected === 'dateIncorporate') ||
            (this.context.expertSourceSelected.length === 0 && this.context.expertSourceSelected === 'expertSource')) {
          this.context.filterSelected = null
        }

        this.initFilters(companies)

        if (this.context.filterSelected === null) {
          if (this.context.countriesSelected.length > 0) {
            this.context.filterSelected = 'country'
          }
          if (this.context.categorySelected.length > 0) {
            this.context.filterSelected = 'category'
          }
          if (this.context.affiliationTypeSelected.length > 0) {
            this.context.filterSelected = 'affiliationType'
          }
          if (this.context.dateIncorporateSelected.length > 0) {
            this.context.filterSelected = 'dateIncorporate'
          }
          if (this.context.expertSourceSelected.length > 0) {
            this.context.filterSelected = 'expertSource'
          }
        }
      }
      companies = this.applyFilters(companies)

      if (companies.length === 0) {
        this.resetFilters()
      }

      this.initFilters(companies)

      companies = this.applyFilters(companies)

      this.applySort(companies)

      this.identifySelectedAndSimilarCompanies(companies)

      let itemsToDisplay = companies.find((item) => {
        return item.display === true
      })

      this.context.hasItemsToDisplay = (typeof itemsToDisplay !== 'undefined') ? true : false
    },
    resetFilters: function () {
      this.context.filterSelected = null
      this.context.countriesSelected = []
      this.context.categorySelected = []
      this.context.affiliationTypeSelected = []
      this.context.dateIncorporateSelected = []
      this.context.expertSourceSelected = []
    },
    initFilters: function (companies) {
      let countriesFilter = []
      let categoryFilter = []
      let affiliationTypeFilter = []
      let dateIncorporateFilter = []
      let affiliationsFilter = []
      let expertSourceFilter = []

      if (this.$auth.user().profile.name === 'schneider') {
        expertSourceFilter.push({nb: 0, name: 'TECHNICAL EDISON'})
      }

      companies.forEach((company) => {
        if (typeof company.affiliation !== 'undefined' && company.display) {
          let country = countriesFilter.find((element) => {
            return element.name === company.affiliation.country
          })

          if (typeof country === 'undefined') {
            countriesFilter.push({nb: 1, name: company.affiliation.country})
          } else {
            ++country.nb
          }

          let category = categoryFilter.find((element) => {
            return element.name === company.affiliation.category
          })

          if (typeof category === 'undefined') {
            categoryFilter.push({nb: 1, name: company.affiliation.category})
          } else {
            ++category.nb
          }

          let affiliationType = affiliationTypeFilter.find((element) => {
            return element.name === Boolean(company.affiliation.isUniversity)
          })

          if (typeof affiliationType === 'undefined') {
            affiliationTypeFilter.push({nb: 1, name: Boolean(company.affiliation.isUniversity)})
          } else {
            ++affiliationType.nb
          }

          let dateIncorporate = dateIncorporateFilter.find((element) => {
            return element.name === company.affiliation.incorporation_date
          })

          if (typeof dateIncorporate === 'undefined') {
            dateIncorporateFilter.push({nb: 1, name: company.affiliation.incorporation_date})
          } else {
            ++dateIncorporate.nb
          }

          let expertSource = expertSourceFilter.find((element) => {
            return (element.name === company.expertSource ||
                (company.expertSource === '' && element.name === null))
          })

          if (typeof expertSource === 'undefined') {
            expertSourceFilter.push({nb: 1, name: company.expertSource})
          } else {
            ++expertSource.nb
          }
        }
        if (typeof company.affiliation !== 'undefined') {
          if (typeof affiliationsFilter[company.affiliation.organisationID] === 'undefined') {
            affiliationsFilter[company.affiliation.organisationID] = {
              nb: 1,
              name: company.affiliation.organisationName,
              id: company.affiliation.organisationID,
              country: company.affiliation.country,
              nb_doc: company.docs.length
            }
          } else {
            ++affiliationsFilter[company.affiliation.organisationID].nb
          }
        }
      })

      countriesFilter.sort((country1, country2) => {
        return country2.nb - country1.nb
      })

      if (expertSourceFilter.length !== 0) {
        let expertSource = expertSourceFilter.find((expertSource) => {
          return expertSource.name === 'TECHNICAL EDISON'
        })
        if (typeof expertSource !== 'undefined') {
          expertSource.name = 'ASTER'
        }
      }

      if (this.context.filterSelected !== 'country' || this.context.countriesFilter.length === 0) {
        this.context.countriesFilter = countriesFilter
      }
      if (this.context.filterSelected !== 'category' || this.context.categoryFilter.length === 0) {
        this.context.categoryFilter = categoryFilter
      }
      if (this.context.filterSelected !== 'affiliationType' || this.context.affiliationTypeFilter.length === 0) {
        this.context.affiliationTypeFilter = affiliationTypeFilter
      }
      if (this.context.filterSelected !== 'dateIncorporate' || this.context.dateIncorporateFilter.length === 0) {
        this.context.dateIncorporateFilter = dateIncorporateFilter
      }
      if (this.context.filterSelected !== 'expertSource' || this.context.expertSourceFilter.length === 0) {
        this.context.expertSourceFilter = expertSourceFilter
      }

      if (this.context.filterSelected === null) {
        this.context.countriesFilter = countriesFilter
        this.context.categoryFilter = categoryFilter
        this.context.affiliationTypeFilter = affiliationTypeFilter
        this.context.dateIncorporateFilter = dateIncorporateFilter
        this.context.expertSourceFilter = expertSourceFilter
      }
      this.$emit('updateCountries', {'countries': this.context.countriesFilter, 'companies': affiliationsFilter})
    },
    applyFilters: function (companies) {
      if (this.context.filterSelected !== null) {
        if (this.context.countriesSelected.length > 0 || this.context.categorySelected.length > 0 ||
            this.context.affiliationTypeSelected.length > 0 || this.context.dateIncorporateSelected.length > 0 ||
            this.context.expertSourceSelected.length > 0) {
          companies = companies.filter((author) => {
            let companyFilterByCountry = true
            let companyFilterByCategory = true
            let companyFilterByAffiliationType = true
            let companyFilterByDateIncorporate = true
            let companyFilterByExpertSource = true

            if (typeof author.affiliation !== 'undefined') {
              this.context.countriesSelected.map((country) => {
                if (author.affiliation.country === country.name) {
                  companyFilterByCountry = false
                }
              })

              this.context.categorySelected.map((category) => {
                if (author.affiliation.category === category.name) {
                  companyFilterByCategory = false
                }
              })

              this.context.affiliationTypeSelected.map((affiliationType) => {
                if (Boolean(author.affiliation.isUniversity) === Boolean(affiliationType.name)) {
                  companyFilterByAffiliationType = false
                }
              })

              this.context.dateIncorporateSelected.map((dateIncorporate) => {
                if (author.affiliation.incorporation_date === dateIncorporate.name) {
                  companyFilterByDateIncorporate = false
                }
              })

              this.context.expertSourceSelected.map((expertSource) => {
                if (author.expertSource === expertSource.name ||
                    (author.expertSource === 'TECHNICAL EDISON' && expertSource.name === 'ASTER')) {
                  companyFilterByExpertSource = false
                }
              })
            }

            let companyFilter = true
            if (companyFilterByCountry === false || companyFilterByCategory === false ||
                companyFilterByAffiliationType === false || companyFilterByDateIncorporate === false ||
                companyFilterByExpertSource === false) {
              companyFilter = false
              if (this.context.countriesSelected.length > 0 && companyFilter === false) {
                companyFilter = companyFilterByCountry
              }
              if (this.context.categorySelected.length > 0 && companyFilter === false) {
                companyFilter = companyFilterByCategory
              }
              if (this.context.affiliationTypeSelected.length > 0 && companyFilter === false) {
                companyFilter = companyFilterByAffiliationType
              }
              if (this.context.dateIncorporateSelected.length > 0 && companyFilter === false) {
                companyFilter = companyFilterByDateIncorporate
              }
              if (this.context.expertSourceSelected.length > 0 && companyFilter === false) {
                companyFilter = companyFilterByExpertSource
              }
            }
            return !companyFilter
          })
        }
      }
      return companies
    },
    applySort: function (companies) {
      switch (this.sort.col) {
        case 'score':
          companies.sort((company1, company2) => {
            if (this.sort.order === 'desc') {
              return company2.score - company1.score
            } else if (this.sort.order === 'asc') {
              return company1.score - company2.score
            }
          })
          break
        case 'country':
          companies.sort((company1, company2) => {
            let country1 = typeof company1.affiliation.country === 'undefined' ? 'zzzzz' : company1.affiliation.country
            let country2 = typeof company2.affiliation.country === 'undefined' ? 'zzzzz' : company2.affiliation.country

            if (this.sort.order === 'desc') {
              return country2.toLowerCase() < country1.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return country1.toLowerCase() < country2.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'affiliation':
          companies.sort((company1, company2) => {
            let name1 = typeof company1.affiliation.organisationName === 'undefined'
              ? 'zzzzz' : company1.affiliation.organisationName
            let name2 = typeof company2.affiliation.organisationName === 'undefined'
              ? 'zzzzz' : company2.affiliation.organisationName

            if (this.sort.order === 'desc') {
              return name2.toLowerCase() < name1.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return name1.toLowerCase() < name2.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'source':
          companies.sort((company1, company2) => {
            let doc1 = company1.docs[0]
            let doc2 = company2.docs[0]

            let name1 = doc1.sourceID
            let name2 = doc2.sourceID

            if (this.sort.order === 'desc') {
              return name2 - name1
            } else if (this.sort.order === 'asc') {
              return name1 - name2
            }
          })
          break
      }
    },
    identifySelectedAndSimilarCompanies: function (companies) {
      if (typeof this.companiesSelected !== 'undefined' && this.companiesSelected !== null &&
          typeof this.companiesSimilar !== 'undefined' && this.companiesSimilar !== null) {
        companies.forEach((company) => {
          company.selected = false
          company.similar = false
          this.companiesSelected.forEach((companySelected) => {
            if (companySelected.authorID === company.authorID) {
              company.selected = true
            }
          })

          this.companiesSimilar.forEach((companySimilar) => {
            if (companySimilar.authorID === company.authorID) {
              company.similar = true
            }
          })
        })
      }

      this.companies = Object.assign([], companies)

      this.setSelectedDocumentInBiblio()
    },
    filterByName: function (companies) {
      companies = companies.filter((company) => {
        return company.lastName.toLowerCase() === this.searchType.lastName.toLowerCase()
      })
      return companies
    },
    changeSort: function (col) {
      this.sort.col = col
      this.sort.order = (this.sort.order === 'desc' ? 'asc' : 'desc')
      this.applySort(this.companies)
    },
    showHidePanelList: function (event) {
      event.preventDefault()
      let hpanel = $(this.$el).closest('div.hpanel') // $(this).closest('div.hpanel')
      let icon = $(this.$el).find('i:first') // $(this).find('i:first')
      let body = hpanel.find('div.panel-body:first')
      let footer = hpanel.find('div.panel-footer:first')

      body.slideToggle(300)
      footer.slideToggle(200)

      // Toggle icon from up to down
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
      hpanel.toggleClass('').toggleClass('panel-collapse')

      setTimeout(function () {
        hpanel.resize()
        hpanel.find('[id^=map-]').resize()
      }, 50)
    }
  },
  beforeMount () {
    this.localAllCompanies = this.allCompanies
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListCompanies/ListCompanies.vue